import {LanguageService} from '@/services/storage.service'

let savedLang = LanguageService.getLanguage()

const state = {
  current_lang: savedLang
}

const mutations = {
  SET_CURRENT_LANGUAGE: (state, payload) => {
    if (['ar'].includes(payload.iso_2 || 'en')) {
      console.log('Switching to RTL', {payload})
      //if (document) document.documentElement.dir = 'rtl'
    } else {
      console.log('Switching to LTR', {payload})
      //if (document) document.documentElement.dir = 'ltr'
    }

    state.current_lang = payload
  }
}

const actions = {
  async setCurrentLang ({ commit, dispatch }, payload) {
    commit(`SET_CURRENT_LANGUAGE`, payload)
  }
}

const getters = {
  isRTL: state => ['ar'].includes(
    state && state.current_lang && !!state.current_lang.lang
      ? state.current_lang.lang : 'en'
  ),
  getCurrentLang: state => state.current_lang,
  getCurrentLangIsoCode: state =>
    state.current_lang && state.current_lang.iso_2
      ? state.current_lang.iso_2.toLowerCase()
      : 'en'
}

const globalStore = {
  state,
  mutations,
  actions,
  getters
}

export default globalStore



// WEBPACK FOOTER //
// ./src/store/modules/global.js